// We only want to index compare pages in these categories and only if they
// have a high rank in popularity. This logic is also reflected in
// our sitemap generator. We do this to avoid bloating our Google index
const versusCategories = ['103', '350', '500', '401'];
const versusProductLimit = 25;

export default ({ data }, { linkTo, t }) => {
  if (!data) {
    return {
      title: t('meta', 'product-compare.title-fallback'),
      noIndex: true,
    };
  }

  const { category, products } = data;

  const isVersus = products && products.length === 2;

  const categoryProps = {};

  const path = linkTo('productCompare', { category, products });
  if (category) {
    categoryProps.thumbnail = category.logo;
    categoryProps.breadcrumb = category.path.concat([
      {
        name: t('category', 'product-compare.breadcrumb'),
        pathName: path,
      },
    ]);
  }

  let noIndex = true;
  let title = t('meta', 'product-compare.title-fallback');
  let description = null;

  if (isVersus) {
    title = t('meta', 'product-compare.versus-title', {
      name1: products[0].name,
      name2: products[1].name,
    });
    description = t('meta', 'product-compare.versus-description', {
      name1: products[0].name,
      name2: products[1].name,
    });

    noIndex = !(
      category &&
      versusCategories.indexOf(category.id) > -1 &&
      products[0].popularity.inCategory <= versusProductLimit &&
      products[1].popularity.inCategory <= versusProductLimit
    );
  } else if (category) {
    title = t('meta', 'product-compare.title', {
      categoryName: category.name,
    });
  }

  return {
    ...categoryProps,
    noIndex,
    title,
    description,
  };
};
